import { styled } from '../../../../modules';

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    background-color: #ffffff;
`;

export const LogoSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 20px 24px;
    border-bottom: 1px solid #e5e5e5;
    flex-shrink: 0;
`;

export const LogoImage = styled.img`
    max-height: 52px;
    max-width: 200px;
    object-fit: contain;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 40px 32px 0;
    gap: 20px;
    text-align: center;
`;

export const CheckCircle = styled.div<{ $color: string }>`
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 3.5px solid ${({ $color }) => $color};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const Title = styled.h1<{ $text: string }>`
    font-size: 24px;
    font-weight: 500;
    color: ${({$text}) => $text};
    margin: 0;
    line-height: 1.3;
`;

export const Subtitle = styled.p`
    font-size: 14px;
    font-weight: 400;
    color: #555;
    margin: 0;
    line-height: 1.6;
`;

export const Separator = styled.div`
    width: calc(100% - 64px);
    height: 1px;
    background-color: #e5e5e5;
    margin-top: 32px;
    flex-shrink: 0;
`;

export const ContactSection = styled.div`
    width: 100%;
    padding: 28px 32px 0;
    text-align: center;
`;

export const ContactText = styled.p`
    font-size: 14px;
    color: #555;
    margin: 0;
    line-height: 1.6;
`;

export const ContactLink = styled.a<{$color: string}>`
    color: ${({$color}) => $color};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;


export const CallbackSection = styled.div`
    width: 100%;
    padding: 28px 32px 0;
    text-align: center;
`;

export const CallbackText = styled.p`
    font-size: 14px;
    color: #555;
    margin: 0;
    line-height: 1.6;
`;

export const CallbackLink = styled.a<{$color: string}>`
    color: ${({$color}) => $color};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;

export const CountdownText = styled.p`
    font-size: 12px;
    color: #999;
    margin: 8px 0 0;
    text-align: center;
`;

export const Button = styled.button<{ $backgroundColor: string; $disabled: boolean }>`
    width: 100%;
    padding: 16px 20px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    background-color: ${({ $backgroundColor, $disabled }) => ($disabled ? '#aaa' : $backgroundColor)};
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: opacity 0.2s;

    &:hover:not(:disabled) {
        opacity: 0.9;
    }
`;

export const Footer = styled.footer`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 24px;
    margin-top: auto;
`;
